// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"ProductSideBar_sidebarContainer__1pYg5","btn":"ProductSideBar_btn__2gEm3"};